import React from 'react';
import { m } from 'framer-motion';
import { GraduationCapIcon, EyeIcon, PrinterIcon, ArrowRightIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const steps = [{
  n: '1',
  title: 'Elige tu curso',
  icon: GraduationCapIcon
}, {
  n: '2',
  title: 'Revisa la clase',
  icon: EyeIcon
}, {
  n: '3',
  title: 'Imprime y enseña',
  icon: PrinterIcon
}];
export function Solution() {
  return <section className="bg-cream py-10 sm:py-14" data-id="element-159" data-mp="97aewv85wllv">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-160" data-mp="95zaquat1bu8">
        <SectionTag data-id="element-161" data-mp="48pqdt29vqd9">La solución</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-162" data-mp="iy5c2umy55m3">
          Matemáticas Listo es tu respuesta
        </h2>
        <p className="mt-4 text-base leading-relaxed text-ink sm:text-lg" data-id="element-163" data-mp="dzu1uisqot3c">
          Conservas los 12 tomos y los 6 bonos del sistema. Además, cada curso incorpora un cuaderno con 30
          clases estructuradas: objetivo, tiempos orientativos, ejemplo explicado, práctica, apoyos, retos y
          comprobación final. Las fichas del alumnado y sus soluciones ya están preparadas.
        </p>
      </div>

      <div className="mx-auto mt-8 flex max-w-3xl flex-col gap-4 px-4 sm:flex-row sm:items-stretch sm:gap-3 sm:px-6" data-id="element-164" data-mp="1zy4qkrh9yasl">
        {steps.map((step, i) => <React.Fragment key={step.n} data-id="element-165" data-mp="29v9ccq77k48v" data-mpi={i}>
            <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex flex-1 flex-col items-center rounded-2xl border border-navy/10 bg-white p-6 text-center" data-id="element-166" data-mp="29s52pdaz4gat">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-orange/10" data-id="element-167" data-mp="2skz8bgmpiw2d">
                <step.icon size={22} className="text-orange-hover" data-id="element-168" data-mp="2xklmpte9uicr" />
              </div>
              <p className="mt-3 font-heading text-base font-bold uppercase tracking-wide text-navy" data-id="element-169" data-mp="32idn7bszfcsk">
                {step.n}. {step.title}
              </p>
            </m.div>
            {i < steps.length - 1 && <ArrowRightIcon size={20} className="mx-auto hidden flex-shrink-0 self-center text-orange/50 sm:block" aria-hidden="true" data-id="element-170" data-mp="27wpv8dxmaz21" />}
          </React.Fragment>)}
      </div>

      <p className="mx-auto mt-8 max-w-xl px-4 text-center text-sm font-semibold leading-relaxed text-navy sm:px-6 sm:text-base" data-id="element-171" data-mp="2vl96n2byrryc">
        Una selección de clases para complementar tu programación y reducir el trabajo de empezar desde cero.
      </p>
    </section>;
}